import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable, of} from 'rxjs';

@HookClass('variable')
export class VariableHook extends BaseHook {

    @Hook('7ee7b6fa-2d41-42bb-b836-9e4a12a162e8')
    public get(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        const variableContext = this.context.getData('flowContext').variableContext;

        const value = this.reduceToValue(input.object.variable, variableContext);

        const output = new NickProcessArtfact();
        output.kind = ArtfactKind.ANY;
        output.object = value
        return of(output);
    }

    @Hook('85194d43-72b6-4f82-811e-fffef40184d3')
    public set(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        const variableContext = this.context.getData('flowContext').variableContext;

        const property = input.object.variable.split('.').pop();
        const properties = input.object.variable.split('.');

        properties.pop();

        let parent: any = properties.reduce((o: any, i: any, index: any) => {
            if (o && (properties.length - 1) > index && o[i] instanceof Map) {
                // @ts-ignore
                return Object.fromEntries(o[i].entries());
            }
            return o ? o[i] : o;
        }, variableContext);

        if (!parent)
            parent = {};

        parent[property] = input.object.data;

        const output = new NickProcessArtfact();
        output.kind = ArtfactKind.ANY;
        output.object = parent[property]
        return of(output);
    }

    private reduceToValue(property: string, context: any) {
        let _value: any;
        if (!property.length)
            _value = context;
        else {
            const properties = property.split('.');
            _value = properties.reduce((o: any, i: any, index: any) => {
                if (o && (properties.length - 1) > index && o[i] instanceof Map) {
                    return Object.fromEntries(o[i].entries());
                }
                return (o ? o[i] : o);
            }, context);
        }

        return _value;
    }
}
